import { useTranslation } from "react-i18next";
import { useState } from "react";
import WoodBoxIcon from "../../../../../assets/icons/woodBox.svg?react";
import { OptionsMembraneModal } from "./optionsMembraneModal";

type OptionsMembraneProps = {
  woodBoxMembranesPriceHT: number;
};

export const OptionsMembrane = ({ woodBoxMembranesPriceHT }: OptionsMembraneProps) => {
  const { t } = useTranslation("boParameters");
  const [showMembraneModal, setShowMembraneModal] = useState<boolean>(false);

  return (
    <div className="flex w-full max-w-[600px] flex-col gap-2 rounded-xl border border-gray-200 bg-white p-6">
      <div className="flex flex-row justify-between gap-4">
        <div className="flex w-fit flex-row items-center gap-4">
          <WoodBoxIcon className="text-black" width={24} height={24} />
          <div className="flex flex-1 flex-col">
            <h3 className="text-lg font-semibold text-black">{t("membraneOption.title")}</h3>
          </div>
        </div>
        <div className="flex flex-row items-center gap-4">
          <button
            type="button"
            onClick={() => setShowMembraneModal(true)}
            className="bg-brand50 text-brand700 h-fit w-fit rounded-lg px-4 py-2 text-sm font-semibold hover:bg-blue-100 focus:outline-hidden"
          >
            {t("membraneOption.edit")}
          </button>
        </div>
      </div>
      <div className="flex flex-row items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
        <p className="text-xs font-medium text-gray-500">{t("membraneOption.priceLabel")}</p>
        <p className="text-sm font-medium text-gray-900">{woodBoxMembranesPriceHT} €</p>
      </div>
      {showMembraneModal && (
        <OptionsMembraneModal
          closeModal={() => setShowMembraneModal(false)}
          title={t("membraneOption.modalTitle")}
          woodBoxMembranesPriceHT={woodBoxMembranesPriceHT}
        />
      )}
    </div>
  );
};
